import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Image as ImageIcon, ScanFace } from 'lucide-react';
const steps = [{
  icon: <ImageIcon className="w-8 h-8 text-tatan-blue" data-id="element-113" />,
  title: 'Describe or Upload',
  description: 'Type your idea or upload a reference photo. Choose your preferred tattoo style from our extensive library.'
}, {
  icon: <Sparkles className="w-8 h-8 text-tatan-blue" data-id="element-114" />,
  title: 'Generate with AI',
  description: 'Our specialized AI creates multiple high-quality, tattoo-ready designs in seconds based on your prompt.'
}, {
  icon: <ScanFace className="w-8 h-8 text-tatan-blue" data-id="element-115" />,
  title: 'Try It On',
  description: 'Use the AR camera to project the design onto your skin. See exactly how it flows with your body before committing.'
}];
export function HowItWorks() {
  return <section className="py-24 md:py-32" data-id="element-116">
      <div className="max-w-7xl mx-auto px-6" data-id="element-117">
        <div className="text-center mb-16" data-id="element-118">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-black tracking-tighter mb-6" data-id="element-119">
            How TATAN works
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-120">
            From concept to skin in three simple steps.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-121">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative p-8 rounded-3xl bg-white/[0.03] border border-white/10 hover:bg-white/[0.05] transition-colors" data-id="element-122">
              <div className="absolute top-8 right-8 text-6xl font-black text-white/[0.03] select-none" data-id="element-123">
                {index + 1}
              </div>
              <div className="w-16 h-16 rounded-2xl bg-tatan-blue/10 flex items-center justify-center mb-6" data-id="element-124">
                {step.icon}
              </div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-125">{step.title}</h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-126">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}